import { isNil } from 'lodash'

const convertBinaryToBool = (binary) => {
  if (binary === '' || isNil(binary)) return ''

  return Boolean(binary)
}

export default convertBinaryToBool
